import React from 'react';
import FooterBlinkHealth from './footer-bh';
import FooterBlinkPharmacyPlus from './footer-bpp';
import FooterSecure from './footer-secure';
type Props = {
  theme?: 'bpp' | 'secure';
  withTopBorder?: boolean;
  exitPath?: string;
};

const Footer = ({ theme, ...props }: Props) => {
  switch (theme) {
    case 'bpp':
      return <FooterBlinkPharmacyPlus {...props} />;

    case 'secure':
      return <FooterSecure />;

    default:
      return <FooterBlinkHealth {...props} />;
  }
};

export default Footer;
